<template>

  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-checklist-report-extract-by-schedule"
      default-excel
      modal
      enable-generate-pdf
      enable-generate-excel
      enable-generate-word
      java-report
      button-title="Extrato"
      title="Extrato de Agenda de Inspeções">

    <t-input-search v-model="form.startDate" date enable-range
                    label="Data Agendado"/>


    <t-input-person customer
                    v-model="form.customerId"/>


    <t-input-code-label enterprise
                        v-model="form.enterpriseId"/>


    <t-input-code-label inspector
                        v-model="form.inspectorId"/>


    <t-input-search v-model="form.statusSchedule" placeholder="Todas" :options="ScheduleStatusType.list"
                    label="Status Agendamento" select/>



  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import ScheduleStatusType from "@/model/types/modules/checklist/ScheduleStatusType";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportExtractSchedule',
  data() {
    return {
      ScheduleStatusType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        startDate: "",
        customerId: 0,
        enterpriseId: 0,
        inspectorId: 0,
        statusSchedule: 0,
      },

    }
  },
  props: {},
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {



    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
